/** Lawsuits / payout totals on the Coverage offer. Corporate is always included. */

export const LAWSUITS_MAX = 9000;
export const LAWSUITS_BASE = 1800;
export const LAWSUITS_PER_EXTRA = 2400;

export const PAYOUT_MAX = 12948;
export const PAYOUT_BASE = 2496;
export const PAYOUT_PER_EXTRA = 3484;

export function coverageMetrics(extraCount: number): {
  lawsuits: number;
  payout: number;
  lawsuitsRatio: number;
  payoutRatio: number;
  barColor: string;
} {
  const extras = Math.max(0, Math.min(3, extraCount));
  const lawsuits = Math.min(LAWSUITS_MAX, LAWSUITS_BASE + extras * LAWSUITS_PER_EXTRA);
  const payout = Math.min(PAYOUT_MAX, PAYOUT_BASE + extras * PAYOUT_PER_EXTRA);
  const barColor =
    extras === 0 ? '#d6493a' : extras === 1 ? '#ff6b15' : extras === 2 ? '#11aa59' : '#0d8a48';
  return {
    lawsuits,
    payout,
    lawsuitsRatio: lawsuits / LAWSUITS_MAX,
    payoutRatio: payout / PAYOUT_MAX,
    barColor,
  };
}
